// import Settings from "../../config/settings"
// export default class Backend
// {
//     constructor(token)
//     {
//         this.token = token;
//         this.url = Settings.backendURL;
//     }
//     setToken(token)
//     {
//         this.token = token;
//     }
//     callBackend(apiCall, callback, method, body, wrapBodyAsJSON = true)
//     {
//         const init = {mode: 'cors'};
//         if (method)
//             init.method = method;
//         else
//             init.method = "GET";
//         if (body)
//             if (wrapBodyAsJSON)
//                 init.body = Backend.wrapJSONBody(body);
//             else
//                 init.body = body;
//         init.headers = new Headers();
//         init.headers.append("Authorization", `${this.token}`);
//         fetch(`${this.url}${apiCall}`, init)
//             .then(async res =>
//             {
//                 let ret;
//                 if (res.ok)
//                 {
//                     try
//                     {
//                         ret = await res.json();
//                     }
//                     catch
//                     {
//                         ret = {ok: true, error: null};
//                     }
//                 } else
//                 {
//                     const {exp} = JSON.parse(sessionStorage.getItem('accessToken'))?.decodedToken
//                     if(!exp || Date.now() >= exp * 1000){
//                         sessionStorage.removeItem("accessToken");
//                         window.location.reload();
//                     }
//                     let body = await res.text();
//                     ret = Object.assign(JSON.parse(body), {error: `Server error response code: ${res.status}. Extra information: "${body}"`});
//                 }
//                 return ret;
//             })
//             .catch(reason => console.error(reason))
//             .then(data =>
//             {
//                 if (callback)
//                     callback(data);
//             })
//             .catch(reason => console.warn(reason));
//     }
//     static wrapJSONBody(obj)
//     {
//         return new Blob([JSON.stringify(obj)], {type: "application/json"});
//     }
// }

import Settings from "../../config/settings";

export default class Backend {
    constructor(token) {
        this.token = token;
        this.url = Settings.backendURL;
    }

    setToken(token) {
        this.token = token;
    }


//     callBackend(apiCall, callback, method, body, wrapBodyAsJSON = true)
// {
//     const init = {mode: 'cors'};
//     if (method)
//         init.method = method;
//     else
//         init.method = "GET";
//     if (body)
//         if (wrapBodyAsJSON)
//             init.body = Backend.wrapJSONBody(body);
//         else
//             init.body = body;
//     init.headers = new Headers();
//     init.headers.append("Authorization", `${this.token}`);
//     fetch(`${this.url}${apiCall}`, init)
//         .then(async res =>
//         {
//             let ret;
//             if (res.ok)
//             {
//                 try
//                 {
//                     ret = await res.json();
//                 }
//                 catch
//                 {
//                     ret = {ok: true, error: null};
//                 }
//             } else
//             {
//                 const accessToken = sessionStorage.getItem('accessToken');
//                 if (accessToken) {
//                     const { exp } = JSON.parse(accessToken)?.decodedToken;
//                     if(!exp || Date.now() >= exp * 1000){
//                         sessionStorage.removeItem("accessToken");
//                         window.location.reload();
//                     }
//                 }
//                 let body = await res.text();
//                 ret = Object.assign(JSON.parse(body), {
//                     error: `Server error response code: ${res.status}. Extra information: "${body}"`,
//                     status: res.status
//                 });
//             }
//             return ret;
//         })
//         .catch(reason => console.error(reason))
//         .then(data =>
//         {
//             if (callback)
//                 callback(data);
//         })
//         .catch(reason => console.warn(reason));
// }

callBackend(apiCall, callback, method, body, wrapBodyAsJSON = true) {
    const init = { mode: 'cors' };
    if (method)
        init.method = method;
    else
        init.method = "GET";
    if (body)
        if (wrapBodyAsJSON)
            init.body = Backend.wrapJSONBody(body);
        else
            init.body = body;
    init.headers = new Headers();
    init.headers.append("Authorization", `${this.token}`);
    
    fetch(`${this.url}${apiCall}`, init)
        .then(async res => {
            let ret;
            if (res.ok) {
                try {
                    ret = await res.json();
                } catch {
                    ret = { ok: true, error: null };
                }
            } else {
                const accessToken = sessionStorage.getItem('accessToken');
                if (accessToken) {
                    const parsedToken = JSON.parse(accessToken);
                    if (parsedToken && parsedToken.decodedToken) {
                        const { exp } = parsedToken.decodedToken;
                        if (!exp || Date.now() >= exp * 1000) {
                            sessionStorage.removeItem("accessToken");
                            window.location.reload();
                        }
                    }
                }
                let body;
                try {
                    body = await res.text();
                    ret = Object.assign(JSON.parse(body), {
                        error: `Server error response code: ${res.status}. Extra information: "${body}"`,
                        status: res.status
                    });
                } catch (e) {
                    ret = {
                        error: `Server error response code: ${res.status}. Unable to parse response body.`,
                        status: res.status
                    };
                }
            }
            return ret;
        })
        .catch(reason => console.error(reason))
        .then(data => {
            if (callback)
                callback(data);
        })
        .catch(reason => console.warn(reason));
}

static wrapJSONBody(obj) {
    return new Blob([JSON.stringify(obj)], { type: "application/json" });
}
}
